import { Capacitor } from '@capacitor/core'

// ── Runtime shell detection ────────────────────────────────────
// Resolved ONCE at module load — the platform can't change at runtime, so a
// module-level singleton (matching the project's composable style) is enough.
//
//   isCapacitor / isNative → running inside the native iOS or Android shell
//   isWeb                  → plain browser (keep the full, rich web experience)
//
// Use this for *logic* decisions (e.g. lighter Lottie renderer on native).
// For *styling*, prefer the `body.is-capacitor` class added by boot/platform.ts
// so the branch stays pure-CSS and the web output is untouched.
const platform = Capacitor.getPlatform() // 'ios' | 'android' | 'web'
const isCapacitor = Capacitor.isNativePlatform()

export default function usePlatform() {
  return {
    platform,
    isCapacitor,
    isNative: isCapacitor,
    isWeb: !isCapacitor,
    isAndroid: platform === 'android',
    isIOS: platform === 'ios',
  }
}
